import { render, staticRenderFns } from "./PaymentFrequencySwitcher.vue?vue&type=template&id=5b4a0b7a"
import script from "./PaymentFrequencySwitcher.vue?vue&type=script&lang=ts"
export * from "./PaymentFrequencySwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports